import { axiosClient } from "shared/axiosInstance";

class CountryService {
  constructor(token, dispatch) {
    this.token = token;
    this.dispatch = dispatch;
  }

  async getNames() {
    return axiosClient(this.dispatch, this.token).get(`/country/names`);
  }
}

export default CountryService;
